// Generic filename-safe slug helper.
// Strips accents/diacritics, lowercases, and collapses anything that isn't
// a-z/0-9 into single hyphens (trimming leading/trailing hyphens).
const COMBINING_DIACRITICAL_MARKS_START = 0x0300;
const COMBINING_DIACRITICAL_MARKS_END = 0x036f;

const stripDiacritics = (value: string): string => {
    let result = '';
    for (const char of value) {
        const codePoint = char.codePointAt(0) ?? 0;
        if (codePoint >= COMBINING_DIACRITICAL_MARKS_START && codePoint <= COMBINING_DIACRITICAL_MARKS_END) {
            continue;
        }
        result += char;
    }
    return result;
};

export const slugify = (value: string): string =>
    stripDiacritics(value.normalize('NFD'))
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
